import React from 'react'
import * as S from './InfoBlock.styled'
import ShipmentSelector from '../ShipmentSelector/ShipmentSelector'
import CityContacts from '../CityContacts/CityContacts'
import SaleLink from '../SaleLink/SaleLink'
import dynamic from 'next/dynamic'

const SelectorAddress = dynamic(() => import('../SelectorAddress/SelectorAddress'), {
    ssr: false
})
const InfoBlock = () => {
    return (
        <S.Container>
            <S.SiteInfoContainer>
                <CityContacts />
                <ShipmentSelector />
                <SelectorAddress />
                <SaleLink />
            </S.SiteInfoContainer>
        </S.Container>
    )
}

export default InfoBlock
